<template>
  <Layout>
    <template v-slot:title>Acceso No Permitido</template>

    <p>
      No tienes permisos para acceder a esta sección
    </p>
    <BaseButton class="mt-12" @click.prevent="back">
      Volver
    </BaseButton>
  </Layout>
</template>

<script>
import backInErrorPages from '@/mixins/backInErrorPages'
import Layout from '@/layouts/ErrorLayout'

export default {
  components: { Layout },
  mixins: [backInErrorPages],
}
</script>
